module.exports = __webpack_public_path__ + "img/BIG.59ccbe40.png";